<template>
    <div class="modal show">
        <div class="modal-backdrop show" :style="{ zIndex: 'unset' }" @click.self="close()"></div>

        <section :style="{ zIndex: 1 }">
            <div class="modal-dialog popup">
                <div class="modal-content">
                    <div class="modal-header">
                        <div class="modal-title">
                            <template v-if="isNew">{{ trans('Create task') }}</template>
                            <template v-else>{{ trans('Update task') }}</template>
                        </div>

                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            @click="close()"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <form
                        @submit.prevent="save"
                        @keydown="form.errors.clear($event.target.name)"
                        id="task-main-form"
                        class="rc-form"
                    >
                        <div class="modal-body">
                            <div v-if="loading" class="text-center mb-2">
                                <i class="icofont-spinner"></i>
                            </div>

                            <div v-if="!loading" class="row">
                                <div class="col-12 form-group">
                                    <label class="form-control-label" for="title">
                                        {{ trans('Title') }}
                                        <span class="required">*</span>
                                    </label>

                                    <input
                                        name="title"
                                        id="title"
                                        v-focus
                                        class="form-control"
                                        :class="{
                                            'is-invalid': form.errors.has('title'),
                                        }"
                                        :disabled="isRequesting"
                                        v-model="form.title"
                                        required
                                        type="text"
                                    />

                                    <div class="invalid-feedback" v-if="form.errors.has('title')">
                                        {{ form.errors.get('title') }}
                                    </div>
                                </div>

                                <div class="col-12 form-group">
                                    <label class="form-control-label" for="title">
                                        {{ trans('Internal ID') }}
                                    </label>

                                    <input
                                        name="internal_id"
                                        id="internal_id"
                                        class="form-control"
                                        :class="{
                                            'is-invalid': form.errors.has('internal_id'),
                                        }"
                                        :disabled="isRequesting"
                                        v-model="form.internal_id"
                                        type="text"
                                    />

                                    <div class="invalid-feedback" v-if="form.errors.has('internal_id')">
                                        {{ form.errors.get('internal_id') }}
                                    </div>
                                </div>

                                <div
                                    class="col-12 form-group"
                                    :class="{
                                        'has-error': form.errors.has('manager_id'),
                                    }"
                                >
                                    <label class="form-control-label" for="manager_id">
                                        {{ trans('Task manager') }}
                                    </label>

                                    <div class="input-group">
                                        <v-select
                                            id="manager_id"
                                            :options="optionsOfPersons"
                                            :reduce="(manager) => manager.id"
                                            label="text"
                                            :modelValue="form.manager_id"
                                            @update:modelValue="form.manager_id = $event"
                                            :placeholder="trans('None')"
                                        >
                                        </v-select>
                                    </div>

                                    <div
                                        class="invalid-feedback"
                                        v-if="form.errors.has('manager_id')"
                                    >
                                        {{ form.errors.get('manager_id') }}
                                    </div>
                                </div>

                                <div
                                    class="col-12 form-group"
                                    :class="{
                                        'has-error': form.errors.has('clientable_id'),
                                    }"
                                >
                                    <label class="form-control-label" for="clientable_id">{{
                                        trans('Client')
                                    }}</label>

                                    <div class="input-group">
                                        <v-select
                                            :options="optionsOfClients"
                                            :modelValue="selectedClient"
                                            @update:modelValue="onClientSelect"
                                            :disabled="isRequesting"
                                            :placeholder="trans('None')"
                                            :getOptionKey="getClientOptionKey"
                                            label="text"
                                            id="clientable_id"
                                        >
                                        </v-select>
                                    </div>

                                    <div
                                        class="invalid-feedback"
                                        v-if="form.errors.has('clientable_id')"
                                    >
                                        {{ form.errors.get('clientable_id') }}
                                    </div>
                                </div>

                                <div
                                    class="col-12 form-group"
                                    :class="{
                                        'has-error': form.errors.has('project_id'),
                                    }"
                                >
                                    <label class="form-control-label" for="project_id">{{
                                        trans('Project')
                                    }}</label>
                                    <v-select
                                        :modelValue="selectedProject"
                                        @update:modelValue="onProjectSelect"
                                        :options="optionsOfProjects"
                                        :placeholder="trans('None')"
                                        :disabled="isRequesting"
                                        label="text"
                                        class="form-control"
                                        id="project_id"
                                        required
                                    >
                                    </v-select>

                                    <div
                                        class="invalid-feedback"
                                        v-if="form.errors.has('project_id')"
                                    >
                                        {{ form.errors.get('project_id') }}
                                    </div>
                                </div>

                                <div
                                    class="col-12 form-group"
                                    :class="{
                                        'has-error': form.errors.has('adress_id'),
                                    }"
                                >
                                    <label class="form-control-label" for="adress_id">
                                        {{ trans('Address') }}
                                    </label>

                                    <div class="input-group">
                                        <v-select
                                            :options="optionsOfAddress"
                                            :modelValue="selectedAddress"
                                            @update:modelValue="onAddressSelect"
                                            label="text"
                                            :placeholder="trans('None')"
                                            id="address_id"
                                        >
                                            <template v-slot:option="option">
                                                <div class="d-center">
                                                    <span
                                                        v-if="option.icon"
                                                        :class="option.icon"
                                                    ></span>
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template v-slot:selected-option="option">
                                                <div class="selected d-center">
                                                    <span
                                                        v-if="option.icon"
                                                        :class="option.icon"
                                                    ></span>
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                    </div>

                                    <div
                                        class="invalid-feedback"
                                        v-if="form.errors.has('adress_id')"
                                    >
                                        {{ form.errors.get('adress_id') }}
                                    </div>
                                </div>
                                <div
                                    class="col-12"
                                    v-if="selectedAddress.relatable_type == 'project'"
                                >
                                    <div class="card mb-1">
                                        <div class="card-body p-2">
                                            <p class="card-text">
                                                <strong>{{ selectedAddress.title }}</strong>
                                                <br />
                                                {{ selectedAddress.street }}
                                                {{ selectedAddress.number }}
                                                {{ selectedAddress.bus }}
                                                <br />
                                                {{ selectedAddress.zip }}
                                                {{ selectedAddress.city }}
                                                <br />
                                                {{ selectedAddress.country }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    v-if="
                                        selectedAddress.relatable_type != 'project' &&
                                        selectedAddress.id != 0
                                    "
                                    class="col-12"
                                >
                                    <div class="row">
                                        <div
                                            class="col-12 form-group"
                                            :class="{
                                                'has-error': form.errors.has('address_title'),
                                            }"
                                        >
                                            <label class="form-control-label" for="address_title"
                                                >{{ trans('Address title') }}
                                                <span class="required">*</span></label
                                            >

                                            <input
                                                name="address_title"
                                                id="address_title"
                                                class="form-control"
                                                :class="{
                                                    'is-invalid': form.errors.has('address_title'),
                                                }"
                                                v-model="form.address_title"
                                                required
                                                :disabled="isRequesting"
                                                type="text"
                                            />

                                            <div
                                                class="invalid-feedback"
                                                v-if="form.errors.has('address_title')"
                                            >
                                                {{ form.errors.get('address_title') }}
                                            </div>
                                        </div>
                                        <div
                                            class="col-6 form-group"
                                            :class="{
                                                'has-error': form.errors.has('street'),
                                            }"
                                        >
                                            <label class="form-control-label" for="street"
                                                >{{ trans('Street') }}
                                                <span class="required">*</span></label
                                            >

                                            <input
                                                name="street"
                                                id="street"
                                                class="form-control"
                                                :class="{
                                                    'is-invalid': form.errors.has('street'),
                                                }"
                                                v-model="form.street"
                                                required
                                                :disabled="isRequesting"
                                                type="text"
                                            />

                                            <div
                                                class="invalid-feedback"
                                                v-if="form.errors.has('street')"
                                            >
                                                {{ form.errors.get('street') }}
                                            </div>
                                        </div>

                                        <div
                                            class="col-3 form-group"
                                            :class="{
                                                'has-error': form.errors.has('number'),
                                            }"
                                        >
                                            <label class="form-control-label" for="number"
                                                >{{ trans('Number') }}
                                                <span class="required">*</span></label
                                            >

                                            <input
                                                name="number"
                                                id="number"
                                                class="form-control"
                                                :class="{
                                                    'is-invalid': form.errors.has('number'),
                                                }"
                                                :disabled="isRequesting"
                                                v-model="form.number"
                                                required
                                                type="text"
                                            />

                                            <div
                                                class="invalid-feedback"
                                                v-if="form.errors.has('number')"
                                            >
                                                {{ form.errors.get('number') }}
                                            </div>
                                        </div>

                                        <div
                                            class="col-3 form-group"
                                            :class="{
                                                'has-error': form.errors.has('bus'),
                                            }"
                                        >
                                            <label class="form-control-label" for="bus">{{
                                                trans('Bus')
                                            }}</label>

                                            <input
                                                name="bus"
                                                id="bus"
                                                class="form-control"
                                                :class="{
                                                    'is-invalid': form.errors.has('bus'),
                                                }"
                                                :disabled="isRequesting"
                                                v-model="form.bus"
                                                type="text"
                                            />

                                            <div
                                                class="invalid-feedback"
                                                v-if="form.errors.has('bus')"
                                            >
                                                {{ form.errors.get('bus') }}
                                            </div>
                                        </div>

                                        <div
                                            class="col-4 form-group"
                                            :class="{
                                                'has-error': form.errors.has('zip'),
                                            }"
                                        >
                                            <label class="form-control-label" for="zip"
                                                >{{ trans('ZIP') }}
                                                <span class="required">*</span>:</label
                                            >

                                            <input
                                                name="zip"
                                                id="zip"
                                                class="form-control"
                                                :class="{
                                                    'is-invalid': form.errors.has('zip'),
                                                }"
                                                :disabled="isRequesting"
                                                v-model="form.zip"
                                                required
                                                type="text"
                                            />

                                            <div
                                                class="invalid-feedback"
                                                v-if="form.errors.has('zip')"
                                            >
                                                {{ form.errors.get('zip') }}
                                            </div>
                                        </div>

                                        <div
                                            class="col-8 form-group"
                                            :class="{
                                                'has-error': form.errors.has('city'),
                                            }"
                                        >
                                            <label class="form-control-label" for="city"
                                                >{{ trans('City') }}
                                                <span class="required">*</span>:</label
                                            >

                                            <input
                                                name="city"
                                                id="city"
                                                class="form-control"
                                                :class="{
                                                    'is-invalid': form.errors.has('city'),
                                                }"
                                                :disabled="isRequesting"
                                                v-model="form.city"
                                                required
                                                type="text"
                                            />

                                            <div
                                                class="invalid-feedback"
                                                v-if="form.errors.has('city')"
                                            >
                                                {{ form.errors.get('city') }}
                                            </div>
                                        </div>
                                        <div
                                            class="col-12 form-group"
                                            :class="{
                                                'has-error': form.errors.has('country'),
                                            }"
                                        >
                                            <label class="form-control-label" for="country"
                                                >{{ trans('Country') }}
                                                <span class="required">*</span></label
                                            >

                                            <input
                                                :disabled="isRequesting"
                                                :class="{
                                                    'is-invalid': form.errors.has('country'),
                                                }"
                                                v-model="form.country"
                                                name="country"
                                                id="country"
                                                class="form-control"
                                                required
                                                type="text"
                                            />

                                            <div
                                                class="invalid-feedback"
                                                v-if="form.errors.has('country')"
                                            >
                                                {{ form.errors.get('country') }}
                                            </div>
                                        </div>
                                        <div class="col-12 checkbox" v-if="form.project_id !== 0">
                                            <label>
                                                <input
                                                    name="save_as_project_address"
                                                    id="save_as_project_address"
                                                    type="checkbox"
                                                    v-model="form.save_as_project_address"
                                                />
                                                {{ trans('Add address as project address') }}
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div
                                    class="col-12 form-group"
                                    :class="{
                                        'has-error': form.errors.has('status_id'),
                                    }"
                                >
                                    <label class="form-control-label" for="status_id">{{
                                        trans('Status')
                                    }}</label>
                                    <v-select
                                        v-model="form.status_id"
                                        :options="optionsOfStatuses"
                                        :disabled="isRequesting"
                                        :reduce="(status) => status.id"
                                        @change="onStatusChange"
                                        label="title"
                                        id="status_id"
                                        class="form-control"
                                        required
                                    >
                                        <template v-slot:option="option">
                                            <div
                                                class="d-center"
                                                :class="{
                                                    'font-italic': option.deleted_at,
                                                }"
                                            >
                                                <span
                                                    class="badge-round round-sm"
                                                    :style="{
                                                        backgroundColor: option.color,
                                                    }"
                                                >
                                                </span>
                                                {{ option.title }}
                                            </div>
                                        </template>
                                        <template v-slot:selected-option="option">
                                            <div
                                                class="selected d-center"
                                                :class="{
                                                    'font-italic': option.deleted_at,
                                                }"
                                            >
                                                <span
                                                    class="badge-round round-sm"
                                                    :style="{
                                                        backgroundColor: option.color,
                                                    }"
                                                >
                                                </span>
                                                {{ option.title }}
                                            </div>
                                        </template>
                                    </v-select>

                                    <div
                                        class="invalid-feedback"
                                        v-if="form.errors.has('status_id')"
                                    >
                                        {{ form.errors.get('status_id') }}
                                    </div>
                                </div>

                                <template v-if="isNew || planning">
                                    <div
                                        class="col-12 col-md-6 form-group"
                                        :class="{
                                            'has-error': form.errors.has('estimated_time'),
                                        }"
                                    >
                                        <label class="form-control-label" for="estimated_time">{{
                                            trans('Estimate')
                                        }}</label>

                                        <input-time
                                            name="estimated_time"
                                            id="estimated_time"
                                            class="form-control"
                                            :class="{
                                                'is-invalid': form.errors.has('estimated_time'),
                                            }"
                                            v-model="form.estimated_time"
                                            required
                                            :disabled="isRequesting"
                                            type="text"
                                        ></input-time>
                                        <div
                                            class="invalid-feedback"
                                            v-if="form.errors.has('estimated_time')"
                                        >
                                            {{ form.errors.get('estimated_time') }}
                                        </div>
                                    </div>

                                    <div
                                        class="col-12 col-md-6 form-group"
                                        :class="{
                                            'has-error': form.errors.has('deadline_at'),
                                        }"
                                    >
                                        <label class="form-control-label" for="deadline_at">{{
                                            trans('Deadline')
                                        }}</label>

                                        <vue-flatpickr
                                            :format="dateFormat"
                                            name="deadline_at"
                                            id="deadline_at"
                                            :class="{
                                                'is-invalid': form.errors.has('deadline_at'),
                                            }"
                                            class="form-control bg-white"
                                            v-model="form.deadline_at"
                                            :disabled="isRequesting"
                                        >
                                        </vue-flatpickr>

                                        <div
                                            class="invalid-feedback"
                                            v-if="form.errors.has('deadline_at')"
                                        >
                                            {{ form.errors.get('deadline_at') }}
                                        </div>
                                    </div>
                                </template>

                                <div
                                    class="col-12 form-group"
                                    :class="{
                                        'has-error': form.errors.has('description'),
                                    }"
                                >
                                    <label class="form-control-label" for="description">{{
                                        trans('Description')
                                    }}</label>

                                    <textarea
                                        v-model="form.description"
                                        id="description"
                                        class="form-control"
                                    ></textarea>

                                    <div
                                        class="invalid-feedback"
                                        v-if="form.errors.has('description')"
                                    >
                                        {{ form.errors.get('description') }}
                                    </div>
                                </div>
                                <div class="col-12 form-group" v-if="isNew">
                                    <label class="form-control-label" for="checklist_id">
                                        {{ trans('Checklist') }}
                                        {{ trans('Template') }}:
                                    </label>
                                    <v-select
                                        v-model="form.checklist_id"
                                        :reduce="(checklist) => checklist.id"
                                        :options="optionsOfChecklists"
                                        :disabled="isRequesting"
                                        :placeholder="trans('None')"
                                        id="checklist_id"
                                        class="form-control"
                                        label="text"
                                    >
                                    </v-select>
                                </div>
                            </div>
                        </div>

                        <div class="modal-footer">
                            <button @click="close()" type="button" class="btn btn-secondary">
                                {{ trans('cancel') }}
                            </button>
                            <button type="submit" class="btn btn-primary">
                                {{ trans('save') }}
                            </button>
                        </div>
                    </form>
                </div>
                <!--/ modal-content -->
            </div>
        </section>
    </div>
</template>

<script>
import { Form } from '../../classes/Form';
import { createPopper } from '@popperjs/core';
import VueFlatpickr from 'vue-flatpickr-component';

export default {
    components: {
        VueFlatpickr,
    },
    data() {
        return {
            config: {
                dateFormat: 'd-m-Y',
            },
            form: new Form({
                title: '',
                internal_id: '',
                clientable_id: 0,
                clientable_type: '',
                project_id: 0,
                status_id: 1,
                manager_id: null,
                estimated_time: '00:00',
                deadline_at: '',
                description: '',
                checklist_id: 0,
                // Address
                new_address: false,
                save_as_project_address: false,
                location_id: null,
                address_title: '',
                street: '',
                number: '',
                bus: '',
                zip: '',
                city: '',
                country: '',
            }),
            isRequesting: false,
            clients: [],
            selectedClient: {
                id: 0,
                text: trans('None'),
            },
            clientAddresses: [],
            projects: [],
            personsCollection: [],
            selectedProject: {
                id: 0,
                text: trans('None'),
            },
            projectAddresses: [],
            selectedAddress: {
                id: 0,
                text: trans('None'),
            },
            taskStatuses: [],
            checklists: [],
            dateFormat: 'dd-mm-yyyy',
            loading: false,
            address_id: 0,
            openLocation: false,
            openProjectAddress: false,
            project_selected: false,
            client_selected: false,
            client_project: false,
            selected: [],
            isLoadingAddresses: false,
            status_changed: false,
        };
    },
    props: {
        task: {
            required: false,
            type: Object,
            default: null,
        },
        planning: {
            required: false,
            type: Boolean,
        },
    },
    methods: {
        withPopper(dropdownList, component, { width }) {
            dropdownList.style.width = width;
            const popper = createPopper(component.$refs.toggle, dropdownList, {
                placement: 'bottom',
                modifiers: [
                    {
                        name: 'flip',
                        options: {
                            fallbackPlacements: ['top'],
                        },
                    },
                ],
            });
            return () => popper.destroy();
        },
        close() {
            this.$emit('close', true);
        },
        init() {
            this.loading = true;
            let taskId = this.task ? this.task.id : 0;

            axios
                .post(
                    route('project.task.get-init-data', {
                        task: taskId,
                    }),
                )
                .then((response) => {
                    let data = response.data;
                    this.clients = data.clients;
                    this.projects = data.projects;
                    this.taskStatuses = data.taskStatuses;
                    this.checklists = data.checklists;
                    this.personsCollection = data.persons;
                    this.setTaskFromProp();
                })
                .catch(() => {})
                .then(() => {
                    this.loading = false;
                });
        },
        save() {
            this.loading = true;

            let url = route('project.task.store');
            let method = 'POST';
            if (!this.isNew) {
                url = route('project.task.update', { task: this.task.id });
                method = 'PUT';
            }

            this.form
                .submit(method, url)
                .then((response) => {
                    this.close();
                    this.$emit('saved', true);
                    if (this.planning == false) {
                        if (this.isNew) {
                            window.location = response.redirect;
                        }
                        this.$emit('saved', true);
                    } else {
                        this.$emit('info', response.task.id);
                        if (this.status_changed) {
                            this.$emit('status', response.task.id);
                        }
                    }
                })
                .catch(() => {})
                .then(() => {
                    this.loading = false;
                });
        },
        onClientSelect(client) {
            this.selectedAddress = {
                id: 0,
                text: trans('None'),
            };
            this.selectedClient = client;
            this.form.clientable_id = client.id;
            this.form.clientable_type = client.type;
            if (
                this.selectedProject.id != 0 &&
                (this.selectedProject.clientable_type != this.form.clientable_type ||
                    (this.selectedProject.clientable_type != null &&
                        this.selectedProject.clientable_id != this.form.clientable_id))
            ) {
                this.onProjectSelect(this.optionsOfProjects[0]);
            }

            if (client.id == 0) {
                this.clientAddresses = [];
                return;
            }

            this.isLoadingAddresses = true;
            var url = route(client.type + '.get-locations', {
                id: client.id,
            });

            axios
                .get(url)
                .then((response) => {
                    this.clientAddresses = response.data.locations;
                })
                .catch(() => {})
                .then(() => {
                    this.isLoadingAddresses = false;
                });
        },
        getClientOptionKey(option) {
            return String(option.type) + String(option.id);
        },
        onProjectSelect(project) {
            this.selectedProject = project;
            this.form.project_id = project.id;

            if (
                project.id != 0 &&
                (project.clientable_type != this.form.clientable_type ||
                    project.clientable_id != this.form.clientable_id)
            ) {
                let client = this.clients.find((client) => {
                    return (
                        project.clientable_type == client.type && project.clientable_id == client.id
                    );
                });
                if (client != null) {
                    if (
                        client.id != 0 &&
                        (this.selectedProject.clientable_type != this.form.clientable_type ||
                            project.clientable_id != this.form.clientable_id)
                    ) {
                        this.onClientSelect(client);
                    }
                }
            }

            if (project.id == 0) {
                this.projectAddresses = [];
                this.selectedAddress = {
                    id: 0,
                    text: trans('None'),
                };
                return;
            }
            if (project.clientable_type == null) {
                this.selectedAddress = {
                    id: 0,
                    text: trans('None'),
                };
            }
            this.isLoadingAddresses = true;
            var url = route('project.get-locations', {
                projectId: project.id,
            });

            axios
                .get(url)
                .then((response) => {
                    this.projectAddresses = response.data.locations;
                    if (project.locations.length === 0) {
                        this.selectedAddress = {
                            id: 0,
                            text: trans('None'),
                        };
                    }
                    if (project.locations.length > 0) {
                        this.onAddressSelect(this.projectAddresses[0]);
                        this.selectedAddress.text = this.projectAddresses[0].title;
                    }
                })
                .catch(() => {})
                .then(() => {
                    this.isLoadingAddresses = false;
                });
        },
        calculateEstimate(estimated_time) {
            const self = this;

            // Estimated time calculation
            let hours = 0,
                minutes = 0,
                estimate = 0;

            minutes = estimated_time % 60;
            hours = (estimated_time - minutes) / 60;

            if (hours < 10) {
                hours = '0' + hours;
            }

            if (minutes < 10) {
                minutes = '0' + minutes;
            }

            estimate = hours.toString() + ':' + minutes.toString();

            return estimate;
        },
        onAddressSelect(address) {
            this.selectedAddress = address;
            this.form.address_title = '';
            this.form.street = '';
            this.form.number = '';
            this.form.bus = '';
            this.form.zip = '';
            this.form.city = '';
            this.form.country = '';
            this.form.location_id = null;
            this.form.new_address = false;

            if (address.id == 0) {
                return;
            }

            if (address.id == 'new') {
                this.form.new_address = true;
                return;
            }

            if (address.relatable_type == 'project') {
                this.form.location_id = address.id;
            } else {
                this.form.new_address = true;
                this.form.address_title = address.title;
                this.form.street = address.street;
                this.form.number = address.number;
                this.form.bus = address.bus;
                this.form.zip = address.zip;
                this.form.city = address.city;
                this.form.country = address.country;
            }
        },
        setTaskFromProp() {
            if (this.isNew) {
                return;
            }

            if (this.task.relatable_type === 'project') {
                let projectToSelect = this.optionsOfProjects.find((project) => {
                    return project.id == this.task.relatable_id;
                });
                this.onProjectSelect(projectToSelect);
            } else if (
                this.task.relatable_type === 'company' ||
                this.task.relatable_type === 'contact'
            ) {
                let clientToSelect = this.optionsOfClients.find((client) => {
                    return (
                        client.id == this.task.relatable_id &&
                        client.type == this.task.relatable_type
                    );
                });
                if (clientToSelect != undefined) {
                    this.onClientSelect(clientToSelect);
                }
            }
            if (this.planning) {
                this.task.location_to_show = this.task.location;
                this.task.status_id = this.task.status.id;
            }
            if (this.task.location_to_show !== null) {
                this.form.location_id = this.task.location_to_show.id;

                if (this.task.location_to_show.relatable_type == 'project') {
                    this.task.location_to_show.text = this.task.location_to_show.title;
                    this.task.location_to_show.icon = 'icofont-chart-flow-2';
                    this.selectedAddress = this.task.location_to_show;
                } else {
                    this.task.location_to_show.text = this.task.location_to_show.title;
                    this.selectedAddress = this.task.location_to_show;

                    this.form.address_title = this.task.location_to_show.title;
                    this.form.street = this.task.location_to_show.street;
                    this.form.number = this.task.location_to_show.number;
                    this.form.bus = this.task.location_to_show.bus;
                    this.form.zip = this.task.location_to_show.zip;
                    this.form.city = this.task.location_to_show.city;
                    this.form.country = this.task.location_to_show.country;
                }
            }
            this.form.setDefaultValues(this.task);
            this.form.estimated_time = this.calculateEstimate(this.task.estimated_time);
        },
        onStatusChange() {
            this.status_changed = false;
            if (this.planning) {
                this.status_changed = true;
            }
        },
    },
    created() {
        this.init();
    },
    computed: {
        isNew() {
            return this.task == null;
        },
        optionsOfClients() {
            let items = [...this.clients];

            items.sort((a, b) => {
                let current = a.text.toUpperCase(),
                    next = b.text.toUpperCase();

                if (current > next) return 1;
                if (current < next) return -1;

                return 0;
            });

            // Only add "None" option if it doesn't already exist
            if (!items.some(item => item.id === 0)) {
                items.unshift({
                    id: 0,
                    type: null,
                    text: trans('None'),
                });
            }
            return items;
        },
        optionsOfProjects() {
            let items = [];

            if (this.form.clientable_id == 0) {
                items = Object.assign(this.projects);
            } else {
                items = this.projects.filter((item) => {
                    return (
                        item.clientable_id == this.form.clientable_id &&
                        item.clientable_type == this.form.clientable_type
                    );
                });
            }

            items = items.map((item) => {
                return {
                    ...item,
                    text: item.title,
                };
            });

            items.sort((a, b) => {
                let current = a.text.toUpperCase(),
                    next = b.text.toUpperCase();

                if (current > next) return 1;
                if (current < next) return -1;

                return 0;
            });

            items.unshift({
                id: 0,
                text: trans('None'),
            });

            return items;
        },
        optionsOfStatuses() {
            const filterValue = this.task ? this.task.status_id : null;
            const task = this.task;
            let items = this.taskStatuses.filter(function (item) {
                if (task && task.status && task.status.deleted_at) {
                    return item.id == filterValue || item.deleted_at == null;
                }
                return item.deleted_at == null;
            });

            return items;
        },
        optionsOfChecklists() {
            let items = this.checklists.map((item) => {
                return {
                    id: item.id,
                    text: item.title,
                };
            });

            items.sort((a, b) => {
                let current = a.text.toUpperCase(),
                    next = b.text.toUpperCase();

                if (current > next) return 1;
                if (current < next) return -1;

                return 0;
            });

            items.unshift({
                id: 0,
                type: null,
                text: trans('None'),
            });

            return items;
        },
        optionsOfPersons() {
            return [
                { id: null, text: trans('None') },
                ...this.personsCollection
            ];
        },
        optionsOfAddress() {
            let items = [];

            this.projectAddresses.forEach((address) => {
                items.push({
                    ...address,
                    text: address.title,
                    icon: 'icofont-chart-flow-2',
                });
            });

            this.clientAddresses.forEach((address) => {
                let icon = 'icofont-building-alt';
                if (address.relatable_type == 'contact') {
                    icon = 'icofont-user-alt-3';
                }
                items.push({
                    ...address,
                    text: trans('Import') + ' ' + address.title,
                    icon: icon,
                });
            });

            items.sort((a, b) => {
                let current = a.text,
                    next = b.text;

                if (current > next) return 1;
                if (current < next) return -1;

                return 0;
            });

            if (
                this.task &&
                this.task.location_to_show &&
                this.task.location_to_show.relatable_type != 'project'
            ) {
                items.unshift({
                    id: this.task.location_to_show.id,
                    text: this.task.location_to_show.title,
                });
            }

            items.unshift({
                id: 'new',
                text: trans('New address'),
            });

            items.unshift({
                id: 0,
                text: trans('None'),
            });

            return items;
        },
    },
};
</script>

<style scoped>
.text-small {
    font-size: 14px;
}
</style>
